// extracted by mini-css-extract-plugin
module.exports = {"logo":"home-module--logo--3E2MT","signup":"home-module--signup--3JZxw"};